import React from 'react';

const ExportIcon = ({ width = 22, height = 21, color = '#AAA2AA', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 22 21" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeWidth={1.6}>
      <path d="M17.698 8.868V2.677h-6.321M17.697 2.676L8 12.373m.919-7.632L1 4.676v15h15l-.033-7.852" />
    </g>
  </svg>
);

export default ExportIcon;
